export { default } from './HeroSlider';
